export default __webpack_public_path__ + "static/media/bg-outro.d00d72bf.png";